/**
 * Delade brand-konstanter för ELvis Hub.
 *
 * Logotyperna serveras ur `public/` i stället för via signerade Supabase-URL:er.
 * De länkarna bar bearer-token med giltighet till 2070 respektive 2036 rakt in i
 * den JS-bundle som levereras till varje besökare — en evig credential för
 * bilder som ändå ska vara publika. Samma skäl som för bakgrundsbilden i
 * tokens.css.
 *
 * Bonus: logotyperna laddas nu från samma origin som appen, så de slipper en
 * extra DNS-uppslagning och TLS-handskakning mot Supabase vid varje sidladdning.
 *
 * Vid byte av logotyp: ersätt filen i `public/` — ingen kod behöver ändras.
 */

/** El-kretsens ordmärke (cyan på transparent). Kräver ljus botten. */
export const EL_KRETSEN_LOGO_URL = '/el-kretsen.png';

/** Svart "Samify."-wordmark för ljus bakgrund (footers etc). */
export const SAMIFY_LOGO_BLACK_URL = '/samify-black.png';

/** Vit "Samify."-wordmark för mörk bakgrund (hero, dark-mode). */
export const SAMIFY_LOGO_WHITE_URL = '/samify-white.png';

export const SAMIFY_HOMEPAGE = 'https://samify.se';
